import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCommentDots, faComments } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowRight,
  faAt,
  faChevronLeft,
  faCommentsDollar,
  faHandHoldingHeart,
  faHeadphonesAlt,
  faHeadset,
  faMugHot,
  faStar,
  faTimes,
  faUsers,
  faHeadphones,
  faCheck,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { StarRatingConfigService, StarRatingModule } from 'angular-star-rating';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ToastrService } from 'ngx-toastr';
import { Subject, of, switchMap, takeUntil } from 'rxjs';
import { catchError, distinctUntilChanged, finalize } from 'rxjs/operators';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccountType_v2, MentogaProducts } from '../../../models/app-enums';
import { addUserData } from '../../../ngrx/data.action';
import {
  selectAlternateLoader,
  selectCarouselProfile,
  selectCategories,
  selectUser,
} from '../../../ngrx/data.reducer';
import { CommonService } from '../../../services/common.service';
import { HelperService } from '../../../services/helper.service';
import { HomeService } from '../../../services/home.service';
import { HttpService } from '../../../services/http.service';
import { LoaderService } from '../../../services/loader.service';
import { MetaService } from '../../../services/meta.service';
import { MixpanelService } from '../../../services/mixpanel.service';
import { ModalService } from '../../../services/modal.service';
import { ResizeService } from '../../../services/resize.service';
import { ButtonComponent } from '../../../shared/button/button.component';
import { PackageModalComponent } from '../../../shared/chat/package-modal/package-modal.component';
import { InputComponent } from '../../../shared/input/input.component';
import { MiniLoadingComponent } from '../../../shared/loaders/mini-loader/mini-loading.component';
import { EmeetModalComponent } from '../../../shared/modals/emeet-modal/emeet-modal.component';
import { ModalComponent } from '../../../shared/modals/modal/modal.component';
import { SliderModalComponent } from '../../../shared/modals/slider-modal/slider-modal.component';
import { SwitchUserComponent } from '../../../shared/modals/switch-user/switch-user.component';
import { FanChatComponent } from '../../fan/fan-chat/chat.component';
import { ReviewsComponent } from '../reviews/reviews.component';
import { BuymecoffeeModalComponent } from './buymecoffee-modal/buymecoffee-modal.component';
import { PhoneModalComponent } from '../../../shared/phone-modal/phone-modal.component';
import { MegaSessionsModalComponent } from './mega-sessions-modal/mega-sessions-modal.component';
import { DirectivesModule } from '../../../tsExtras/directives.module';
import { ExpertCarouselComponentProfile } from '../../../shared/expertCarouselProfile/expertCarousel.component';
import { MegaSessionCardComponent } from '../../../shared/mega-session-card/mega-session-card.component';
import { PackageCardComponent } from '../../../shared/package-card/package-card.component';
import { ReviewCardComponent } from '../../../shared/review-card/review-card.component';
import { ProfileHeaderComponent } from '../../../shared/profile-header/profile-header.component';
import { SessionRecordingBannerComponent } from '../../../shared/session-recording-banner/session-recording-banner.component';
import { LoadingComponent } from '../../../shared/loaders/loading/loading.component';
import moment from 'moment';
import { CurrencyService } from '../../../services/currency.service';
import { CartModalComponent } from "../../../shared/modals/cart-modal/cart-modal.component";
import { CartIconButtonComponent } from "../../../shared/cart-icon-button/cart-icon-button.component";
declare var $: any;
@Component({
  standalone: true,
  imports: [
    CommonModule,
    LazyLoadImageModule,
    ModalComponent,
    FanChatComponent,
    FontAwesomeModule,
    ReviewsComponent,
    SwitchUserComponent,
    MiniLoadingComponent,
    EmeetModalComponent,
    SliderModalComponent,
    BuymecoffeeModalComponent,
    ExpertCarouselComponentProfile,
    StarRatingModule,
    PackageModalComponent,
    InputComponent,
    ButtonComponent,
    PhoneModalComponent,
    MegaSessionsModalComponent,
    TabsModule,
    DirectivesModule,
    RouterModule,
    MegaSessionCardComponent,
    PackageCardComponent,
    SessionRecordingBannerComponent,
    ReviewCardComponent,
    LoadingComponent,
    ProfileHeaderComponent,
    CartModalComponent,
    CartIconButtonComponent
  ],
  providers: [StarRatingConfigService],
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
})
export class ProfilePageComponent implements OnInit, OnDestroy, AfterViewInit {
  faArrowRight = faArrowRight;
  faChevronLeft = faChevronLeft;
  faStar = faStar;
  faMegaSession = faUsers;
  faChat = faCommentDots;
  faPhone = faHeadphones;
  faAt = faAt;
  faUsers = faHeadset;
  faCircleCheck = faCircleCheck;
  faCommentsDollar = faCommentsDollar;
  creatorResponse: any = null;
  creatorDetails: any;
  creatorProducts: any;
  creatorRatings: any;
  creatorPackages: any;
  uniqueName: string;
  aboutMe: string;
  shortBio: string;
  fullName: string;
  countryCode: string;
  iscountryPK: boolean = false;
  pageNotFoundHtml: boolean = false;
  coffeeRecurringPayment: boolean = false;
  isLoadingBtn: boolean = false;
  isLoading: boolean = false;
  isAllProductActive: boolean = false;
  isAllProductActive2: boolean = false;
  showEmeetModal: boolean = false;
  packageBuyModal: boolean = false;
  megaSessionBuyModal: boolean = false;
  categorizedProducts = {
    isActiveTextProduct: [],
    isActiveAudioProduct: [],
    isActiveVideoProduct: [],
    isActiveeMeetProduct: [],
  };
  localStorageUser: any;
  emeetModal: boolean = false;
  buyMeCoffee: boolean = false;
  faComments = faComments;
  faTimes = faTimes;
  faHeadPhone = faHeadphonesAlt;
  faMugHot = faMugHot;
  faCheck = faCheck;
  fanEmail: boolean = false;
  guestPhone: boolean = false;
  faHandHoldingHeart = faHandHoldingHeart;
  packageId: number;
  sessionPrice: number;
  token: any;
  stripePageHtml: boolean = false;
  creatorCategoryId: number = null;
  isUserSame: boolean = false;
  activeProductId: number;
  menteeId: any = '';
  currentUrl: string = null;
  charityAmount: number;
  charityName: string;
  ischarityActive: boolean;
  activeTab: string = 'content1';
  user$ = this.store.select(selectUser);
  scrollTop: number = 0;
  chatLoading: boolean = false;
  carouselDataInput: any = [];
  randomNumber: number = 0;
  private destroy$ = new Subject<void>();
  showGuestChat = false;
  videoModal: boolean = false;
  switchUserModal: boolean = false;
  guestEmail;
  carousel$ = this.store.select(selectCarouselProfile);
  loader$ = this.store.select(selectAlternateLoader);
  carouselLoader: boolean = false;
  dataLoaded: boolean = false;
  redirectUrl: any = null;
  showFullBio: boolean = false;
  GuestForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });
  functionToCall: any;
  collectionRedirectPath: any = localStorage.getItem('collectionRedirectPath');
  categories: Array<any> = [];
  categories$ = this.store.select(selectCategories);

  tabs = [
    { label: 'Mega Sessions' },
    { label: 'Paid Calls' },
    { label: 'Membership Packages' },
    { label: 'Reviews' },
  ];
  selectedTab = 0;

  selectedMegaSession: any;
  overviewPackages = [];
  overviewMegaSessions = [];
  overviewReviews = [];
  hoveredIndex: number = -1; // Track hovered card index
  megaSessionHoveredIndex: number = -1; // Track hovered card index
  modalPackage: any;

  megaSessionRecordings = [];

  fbLink: string = '';
  instaLink: string = '';
  xLink: string = '';
  linkedinLink: string = '';
  ytLink: string = '';
  tiktokLink: string = '';

  isMobile: boolean = false;

  creatorReviews = [];
  cartModal: boolean = false;
  storedCartItems: any = localStorage.getItem('cartItems');
  cartItems: any[] = this.storedCartItems ? JSON.parse(this.storedCartItems) : [];
  @ViewChildren('section') sections!: QueryList<ElementRef>;
  handleAddToCart(session: any) {
    if (!this.isInCart(session)) {
      this.cartItems.push(session);
      localStorage.setItem('cartItems', JSON.stringify(this.cartItems));
    }
  }
  selectTab(index: number): void {
    this.selectedTab = index;
    // console.log('this.selectedTab', this.selectedTab);
    const className = `.section-${index}`;
    const element = document.querySelector(className);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  constructor(
    private activatedRoute: ActivatedRoute,
    public resize: ResizeService,
    public helper: HelperService,
    private store: Store,
    private renderer: Renderer2,
    private _homeService: HomeService,
    private router: Router,
    private metaService: MetaService,
    private toastr: ToastrService,
    private http: HttpService,
    private _commonService: CommonService,
    private mix: MixpanelService,
    private modalService: ModalService,
    private fb: FormBuilder,
    private currencyService: CurrencyService
  ) {
    if (localStorage.getItem('functionToCall')) {
      this.functionToCall = localStorage.getItem('functionToCall');
      localStorage.removeItem('functionToCall');
      this.functionToCallAfterSwithch();
    }
    this.loader$
      .pipe(
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe((loader: boolean) => {
        this.carouselLoader = loader;
      });
    this.carousel$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((carousel) => {
        if (carousel?.length) {
          this.carouselDataInput = carousel;
          // console.log('carouselDataInput: ', this.carouselDataInput);

        }
      });
    this.categories$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((categories) => {
        this.categories = categories;
      });
    this.user$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((user) => {
        this.localStorageUser = user;
        this.currentUrl = this.router.url;
        this.token = this.localStorageUser?.token;
        if (this.localStorageUser?.id)
          this.menteeId = this.localStorageUser?.id;
      });
    this.modalService.getModalStateObservable().subscribe((state: any) => {
      this[state?.id] = state?.show;
    });

    this.resize.windowSize$.subscribe((size) => {
      // console.log('size: ', size);
      if (size.width <= 540) {
        this.isMobile = true;
      }
    });
  }
  ngAfterViewInit(): void {
    this.sections.changes.subscribe((sections: QueryList<ElementRef>) => {
      this.observeSections(sections);
    });

    // Also observe the sections that are already loaded
    if (this.sections.length) {
      this.observeSections(this.sections);
    }
  }
  observeSections(sections: QueryList<ElementRef>) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // console.log(`Visible: ${entry.target.className}`);
          if (entry.target.className.includes("mainBg")) {
            this.selectedTab = 0;
          }
          else if (entry.target.className.includes("0")) {
            this.selectedTab = 0;
          }
          else if (entry.target.className.includes("1")) {
            this.selectedTab = 1;
          }
          else if (entry.target.className.includes("2")) {
            this.selectedTab = 2;
          }
          else if (entry.target.className.includes("3")) {
            this.selectedTab = 3;
          }
          else if (entry.target.className.includes("4")) {
            this.selectedTab = 4;
          }
        }
      });
    }, {
      threshold: 0.2 // 20% visible triggers
    });

    sections.forEach(section => {
      observer.observe(section.nativeElement);
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnInit(): void {
    if (localStorage.getItem('guestUserFrom') == 'Package') {
      this.helper.removeGuestUser();
      localStorage.removeItem('guestUserFrom');
    }
    if (localStorage.getItem('guestUser') !== null) {
      localStorage.removeItem('guestUser');
    }
    if (this.router.url == '/creators' || this.router.url == '/creators/') {
      setTimeout(() => {
        this.router.navigateByUrl('/creators/' + this.collectionRedirectPath);
      });
    } else {
      this.activatedRoute.queryParams.subscribe((res: any) => {
        if (res?.showcoffee) {
          this.buyMeACoffee();
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { showcoffee: null },
            queryParamsHandling: 'merge',
          });
        }
      });
      this.activatedRoute.paramMap
        .pipe(
          switchMap((paramMap: ParamMap) => {
            this.uniqueName = paramMap.get('uniqueName');
            this.isLoading = true;
            this.activeTab = 'content1';
            this.showEmeetModal = false;
            return this._homeService.getCreatorDetailsByUniqueName(this.uniqueName);
          }),
          switchMap((response) => {


            if (this.uniqueName) {
              if (response.status) {
                localStorage.setItem(
                  'creatorDetails',
                  JSON.stringify(response.model),
                );
                this.creatorResponse = response.model;

                if (this.creatorResponse?.id && this.creatorResponse?.categoryId) {
                  this.helper.getCarouselDataProfile(this.creatorResponse?.id, this.creatorResponse?.categoryId);
                }

                if (this.creatorResponse?.id) {
                  console.log('this.creatorResponse?.id: ', this.creatorResponse?.id);
                  this.fetchMegaSessionsAndRecordings(this.creatorResponse?.id);
                  this.fetchReviews(this.creatorResponse?.id);
                  this.fetchProductsAndPackages(this.creatorResponse?.id);
                }

                this.aboutMe = response?.model?.mentorDetails?.[0]?.aboutMe;
                this.shortBio = response?.model?.mentorDetails?.[0]?.shortBio;
                this.charityName = response?.model?.mentorCharities?.[0]?.name;
                this.charityAmount = response?.model?.mentorCharities?.[0]?.percentAmount;
                this.ischarityActive = response?.model?.mentorCharities?.[0]?.isActive;
                this.fullName = response?.model?.fullName;
                this.creatorCategoryId = response?.model?.categoryId;
                this.creatorDetails = response?.model?.mentorDetails;
                this.creatorRatings = response?.model?.mentorRatings;

                // console.log('creatorPackages: ', this.creatorPackages);
                if (response?.model?.socialHandles && response?.model?.socialHandles?.length > 0) {
                  response?.model?.socialHandles?.forEach((social) => {
                    if (social.title == 'Facebook' && social.value) {
                      this.fbLink = `${social.prefix}${social.value}`;
                    } else if (social.title == 'Instagram' && social.value) {
                      this.instaLink = `${social.prefix}${social.value}`;
                    } else if (social.title == 'X' && social.value) {
                      this.xLink = `${social.prefix}${social.value}`;
                    } else if (social.title == 'LinkedIn' && social.value) {
                      this.linkedinLink = `${social.prefix}${social.value}`;
                    }
                    else if (social.title == 'YouTube' && social.value) {
                      this.ytLink = `${social.prefix}${social.value}`;
                    }
                    else if (social.title == 'TikTok' && social.value) {
                      this.tiktokLink = `${social.prefix}${social.value}`;
                    }
                  });
                }

                if (response.model.id == this.localStorageUser?.id)
                  this.isUserSame = true;
                //this.updateMetaTags();
                this.sendProfileViewEvent();
                this.mix.trackPageVisit(
                  null,
                  this.uniqueName,
                  'Profile View',
                  'Profile',
                  this.fullName,
                  'Profile',
                );
                this.activatedRoute.fragment
                  .pipe(
                    takeUntil(this.destroy$),
                    distinctUntilChanged(
                      (prev, curr) =>
                        JSON.stringify(prev) === JSON.stringify(curr),
                    ),
                  )
                  .subscribe((fragment) => {
                    if (fragment == 'emeet') {
                      this.eMeetingModal();
                    }
                  });
                this.isLoading = false;
              } else {
                this.toastr.error(response?.errorMessage || response?.error || 'Creator not found!');
                this.router.navigate(['/']);
              }
            } else {
              this.toastr.error('Unique name not found!');
              this.router.navigate(['/']);
            }
            return of(null);
          }),
          catchError((error) => {
            console.error('error: ', error);
            let errorMessage = 'Something went error while fetching creator profile!';

            if (typeof error === 'string') {
              errorMessage = error;
            } else if (error?.message || error?.statusText) {
              errorMessage = error?.message || error?.statusText;
            }

            this.toastr.error(errorMessage);
            this.router.navigate(['/']);
            this.isLoading = false;
            return of(null);
          }),
        )
        .pipe(
          takeUntil(this.destroy$),
          distinctUntilChanged(
            (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
          ),
        )
        .subscribe();
    }
    this.currencyService.getCountryCodeDefault().subscribe({
      next: (response: any) => {
        this.countryCode = response.country;
        if (this.countryCode === "PK") {
          this.iscountryPK = true;

        }
      },
      error: (err) => {
        console.error('Error getting country code:', err);
        this.countryCode = 'US';
      }
    });
  }



  openAllRecordedSessions() {
    this.router.navigate([`/recordings/${this.creatorResponse?.id}`]);
  }

  openAllMegaSessions() {
    this.router.navigate([`/mega-sessions/${this.creatorResponse?.id}`]);
  }

 openAllReviews() {
  console.log(this.creatorResponse?.id,"idddd")
    this.router.navigate([`/mentor-review/${this.creatorResponse?.id}`]);
  }

  async fetchReviews(creatorId) {
    try {
      if (!creatorId) {
        return;
      }
      const response: any = await this.http
        .get(
          `api/MentorRating/mentor-review-listing?mentorid=${creatorId}`,
          false,
          false,
        )
        .toPromise();

      if (response.status) {
        this.creatorReviews = response.modelList;
        // console.log('this.creatorReviews', this.creatorReviews);
        this.overviewReviews = this.creatorReviews.slice(0, 3);
        if (this.overviewReviews?.length > 0) {
          // console.log('this.overviewReviews 1', this.overviewReviews);
          this.overviewReviews.forEach((review) => {
            // Format the date
            review.formattedDate = this.formatDate(review.reviewDate);
          });
        }
        // console.log('this.overviewReviews', this.overviewReviews);

      } else {
        this.overviewReviews = [];
        // console.log('this.creatorReviews', this.creatorReviews);
      }
    } catch (error) {
      console.error('An error occurred while loading data:', error);
      this.overviewReviews = [];
    } finally {
    }
  }

  async fetchProductsAndPackages(creatorId) {
    try {
      if (!creatorId) {
        return;
      }
      const response: any = await this.http
        .get(
          `api/Home/profile/productnpackages/${creatorId}`,
          false,
          false,
        )
        .toPromise();

      if (response.status) {

        this.creatorProducts = response?.model?.products;
        this.creatorPackages = response?.model?.packages;
        this.overviewPackages = response?.model?.customPackages?.slice(
          0,
          4,
        );
        // ✅ Convert package prices if country is PK


        if (this.countryCode === 'PK' && Array.isArray(this.overviewPackages)) {
          const conversionTasks = this.overviewPackages.map(async (item) => {
            const convertedPrice = await this.currencyService.convertCurrencyV1(item.price).toPromise();
            const convertedActual = await this.currencyService.convertCurrencyV1(item.actualPrice).toPromise();
            const convertedSavings = await this.currencyService.convertCurrencyV1(item.savings).toPromise();

            item.price = convertedPrice;
            item.actualPrice = convertedActual;
            item.savings = convertedSavings;

            return item;
          });

          await Promise.all(conversionTasks);


        }
        this.loadProductsOnView(
          this.creatorProducts,
          this.creatorPackages,
        );

      } else {

        this.creatorProducts = [];
        this.creatorPackages = [];
        this.overviewPackages = [];
      }
    } catch (error) {
      console.error('An error occurred while loading data:', error);
      this.creatorProducts = [];
      this.creatorPackages = [];
      this.overviewPackages = [];
    } finally {
    }
  }

  async fetchMegaSessionsAndRecordings(creatorId) {
    try {
      if (!creatorId) {
        return;
      }
      const response: any = await this.http
        .get(
          `api/Home/profile/megasessionsnrecordings/${creatorId}`,
          false,
          false,
        )
        .toPromise();

      if (response.status) {
        // console.log('response: ', response);

        this.overviewMegaSessions = response?.model?.megasessions?.slice(
          0,
          3,
        );

        if (this.overviewMegaSessions?.length > 0) {
          this.overviewMegaSessions.forEach((session) => {
            if (session?.slots?.length > 0) {
              const firstSlot = session.slots[0];

              // Parse timing and calculate duration
              const fromTiming = this.parseTime(
                firstSlot.slotDatetime,
                firstSlot.fromTiming,
              );
              const toTiming = this.parseTime(
                firstSlot.slotDatetime,
                firstSlot.toTiming,
              );
              // Format the date
              session.formattedDate = this.helper.formatDate(
                firstSlot?.slotDatetime,
                firstSlot?.fromTiming,
              );

              if (this.countryCode === "PK") {
                this.currencyService.convertCurrencyV1(session.price).subscribe((convertedAmount) => {
                  session.price = convertedAmount;
                });
              }
            }
          });
        }


        this.megaSessionRecordings = response?.model?.megasessionRecordings?.slice(
          0,
          3,
        );

        if (this.megaSessionRecordings?.length > 0) {
          this.megaSessionRecordings.forEach((session) => {

            if (session?.slot) {
              const slot = session.slot;
              slot.formattedDate = this.helper.formatDate(
                slot?.slotDatetime,
                slot?.fromTiming,
              );

              const hoursConvert24 = moment(
                slot.fromTiming,
                'hh:mm A',
              ).format('HH:mm');
              const makeDateFormat = moment(
                slot.slotDate + 'T' + hoursConvert24 + 'Z',
                'YYYY-MM-DDTHH:mmZ',
              ).format('dddd DD-MMM-YYYY');
              const fromTimingLocal = moment
                .utc(slot.fromTiming, 'LT')
                .local()
                .format('LT');
              const toTimingLocal = moment
                .utc(slot.toTiming, 'LT')
                .local()
                .format('LT');

              slot.fromTiming = fromTimingLocal;
              slot.toTiming = toTimingLocal;
              slot.convertedTime = makeDateFormat;

              let recordingId = session?.id;
              session.recordingId = recordingId;
              session.mentorId = creatorId;
              session.slotId = slot.id;
              session.mentor = {
                fullName: this.creatorResponse.fullName
              };
              const megaSession = session?.megaSession;

              session.duration = megaSession?.duration || 0;
              session.formattedDate = `${slot.formattedDate} | ${slot.fromTiming}`;
              session.title = megaSession?.title || '-';
              session.description = megaSession?.description || '-';
              if (this.countryCode === "PK") {
                this.currencyService.convertCurrencyV1(session.price).subscribe((convertedAmount) => {
                  session.price = convertedAmount;
                });
              }
            }
          });
        }


      } else {
        // this.creatorReviews = [];
        this.overviewMegaSessions = [];
        this.megaSessionRecordings = [];
      }
    } catch (error) {
      console.error('An error occurred while loading data:', error);
      // this.creatorReviews = [];
      this.overviewMegaSessions = [];
      this.megaSessionRecordings = [];
    } finally {
    }
  }

  goBackToPrevPage() {
    const categoryNameObj = this.categories.find(
      (category) => category?.id === this.creatorCategoryId,
    );

    if (categoryNameObj?.path) {
      this.router.navigateByUrl('/creators/' + categoryNameObj?.path);
    } else {
      this.router.navigateByUrl('/creators/');
    }
  }
  sendProfileViewEvent() {
    this._commonService.pixelAction(
      'Profile View',
      this.menteeId,
      this.currentUrl,
      this.fullName?.toLowerCase(),
      '',
      0,
      this.creatorResponse?.email?.toLowerCase(),
      null,
      null,
      null,
      null,
      this.uniqueName,
    );
  }

  sendProductSelectEvent(product, price) {
    this._commonService.pixelAction(
      'Product Select',
      this.menteeId,
      this.currentUrl,
      this.fullName?.toLowerCase(),
      product,
      price,
      this.creatorResponse?.email?.toLowerCase(),
      null,
      null,
      null,
      null,
      this.uniqueName,
    );
  }

  onChatProductClick(mentorProductId) {
    this.sendProductSelectEvent(
      'Chat',
      this.categorizedProducts.isActiveTextProduct[0]?.price,
    );
    if (!this.isUserSame) {
      if (this.localStorageUser) {
        if (this.localStorageUser?.userTypeId == AccountType_v2.Fan) {
          this.chatLoading = true;
          this._homeService
            .getChatBookingDetailsAsync(mentorProductId)
            .pipe(
              takeUntil(this.destroy$),
              finalize(() => {
                this.chatLoading = false;
              }),
              distinctUntilChanged(
                (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
              ),
            )
            .subscribe({
              next: (response: any) => {
                if (response.status) {
                  localStorage.setItem('contactId', response.model.contactId);
                  localStorage.setItem('bookingId', response.model.bookingId);
                  localStorage.setItem('mentorProductId', mentorProductId);
                  this.router.navigate(['fan/chat']);
                } else {
                  console.error(
                    'get chat booking api status false: ',
                    response.errorMessage,
                  );
                }
              },
              error: (error: any) => {
                console.error('get chat booking api error: ', error);
              },
            });
        } else {
          this.functionToCall = 'chatProduct';
          this.helper.showModal(true, 'switchUserModal');
        }
      } else {
        localStorage.setItem('mentorProductId', mentorProductId);
        this.showGuestChat = true;
        window.scrollTo(0, 0);
      }
    }
  }
  functionToCallAfterSwithch() {
    if (this.functionToCall == 'chatProduct') {
      this.onChatProductClick(
        this.categorizedProducts.isActiveTextProduct[0]?.id,
      );
    } else if (this.functionToCall == 'eMeetModal') {
      this.eMeetingModal();
    } else if (this.functionToCall == 'buyMeCoffee') {
      this.buyMeACoffee();
    } else if (this.functionToCall == 'megaSessions') {
      // this.openMegaSessions();
    } else {
      this.openPackage();
    }
  }
  eMeetingModal() {
    if (this.isAllProductActive2) {
      this.sendProductSelectEvent('eMeet', this.creatorPackages[0]?.price);
      if (!this.isUserSame) {
        if (this.localStorageUser) {
          if (this.localStorageUser?.userTypeId == AccountType_v2.Creator) {
            this.functionToCall = 'eMeetModal';
            this.helper.showModal(true, 'switchUserModal');
          } else {
            this.buyMeCoffee = false;
            this.emeetModal = true;
            this.openModal();
          }
        } else {
          this.buyMeCoffee = false;
          this.emeetModal = true;
          this.openModal();
        }
      } else {
        this.toastr.error("You can't book your own slots!");
      }
    }
  }

  buyMeACoffee() {
    this.sendProductSelectEvent('Coffee', 3);
    if (!this.isUserSame) {
      if (this.localStorageUser) {
        if (this.localStorageUser?.userTypeId == AccountType_v2.Fan) {
          this.emeetModal = false;
          this.buyMeCoffee = true;
          this.openModal();
        } else {
          this.functionToCall = 'buyMeCoffee';
          this.helper.showModal(true, 'switchUserModal');
        }
      } else {
        this.emeetModal = false;
        this.buyMeCoffee = true;
        this.openModal();
      }
    }
  }

  toggleContent(contentId: string, elem: MouseEvent) {
    elem.preventDefault();
    let contentElement = document.getElementById(contentId);
    const removeClassElements = document.querySelectorAll('.show');
    const removeBtnClassElements = document.querySelectorAll('.btn-dark');
    Array.from(removeClassElements).forEach((element) =>
      element.classList.remove('show'),
    );
    Array.from(removeBtnClassElements).forEach((element) =>
      element.classList.remove('btn-dark'),
    );
    const targetElement = elem.target as HTMLElement;
    this.renderer.addClass(targetElement, 'btn-dark');
    contentElement.classList.toggle('show');
  }

  loadProductsOnView(_creatorProducts: any[], _creatorPackages: any[]) {
    if (!_creatorProducts || _creatorProducts.length === 0) {
      return;
    }
    const SEARCH_TEXT = 'text';
    const SEARCH_AUDIO = 'audio';
    const SEARCH_VIDEO = 'video';
    const SEARCH_EMEET = 'emeet';

    const categoryMap: { [searchString: string]: any[] } = {
      [SEARCH_TEXT]: this.categorizedProducts.isActiveTextProduct,
      [SEARCH_AUDIO]: this.categorizedProducts.isActiveAudioProduct,
      [SEARCH_VIDEO]: this.categorizedProducts.isActiveVideoProduct,
      [SEARCH_EMEET]: this.categorizedProducts.isActiveeMeetProduct,
    };

    _creatorProducts.forEach((item) => {
      const productNameLower = item.productName?.toLowerCase();
      const isActive = item.isActive;
      if (this.countryCode === "PK") {
        this.currencyService.convertCurrencyV1(item.price).subscribe((convertedAmount) => {
          item.price = convertedAmount;
        });
      }

      if (isActive && item.productId != MentogaProducts.Emeet) {
        this.isAllProductActive = true;
      }
      for (const searchString in categoryMap) {
        if (productNameLower.includes(searchString)) {
          categoryMap[searchString].push(item);
          break;
        }
      }
    });
    let filteredPackagesList = [];

    if (_creatorPackages) {
      _creatorPackages.forEach((item) => {
        if (item.isActive) {
          this.isAllProductActive2 = true;
        }
        if (this.countryCode === "PK") {
          this.currencyService.convertCurrencyV1(item.price).subscribe((convertedAmount) => {
            item.price = convertedAmount;
            console.log(convertedAmount, "Amount")
            filteredPackagesList.push(item);

          });
        } else {
          filteredPackagesList.push(item);

        }
      });
      this.creatorPackages = filteredPackagesList;
    }
  }
  openModal() {
    console.log('openModal');
    this.helper.openModal();
  }
  handleViewUpdate(updatedView: boolean, propertyName: string) {
    this[propertyName] = updatedView;
  }
  openPackage() {
    this.buyMeCoffee = false;
    if (this.localStorageUser) {
      if (this.localStorageUser?.userTypeId == AccountType_v2.Fan) {
        this.packageBuyModal = true;
        this.helper.openModal();
      } else {
        this.functionToCall = 'membershipPackage';
        this.helper.showModal(true, 'switchUserModal');
      }
    } else {
      this.packageBuyModal = true;
      this.helper.openModal();
    }
  }

  navigateToSessionDetails(session: any) {
    this.router.navigate([`/${this.uniqueName}/mega-session/${session?.id}`]);
  }

  openMegaSessions(selectedSession) {
    if (this.localStorageUser) {
      if (this.localStorageUser?.userTypeId == AccountType_v2.Fan) {
        this.selectedMegaSession = selectedSession;
        this.megaSessionBuyModal = true;
        this.helper.showModal(true, 'megaSessionBuyModal');
      } else {
        this.functionToCall = 'megaSessions';
        this.helper.showModal(true, 'switchUserModal');
      }
    } else {
      this.selectedMegaSession = selectedSession;
      this.megaSessionBuyModal = true;
      this.helper.showModal(true, 'megaSessionBuyModal');
    }
  }

  generateRandomNumber() {
    this.randomNumber = Math.floor(Math.random() * 4);
  }
  updateMetaTags() {
    const title = `${this.creatorResponse?.fullName}: Chat & Meet on Mentoga`;
    const description = `Engage with ${this.creatorResponse?.fullName} on Mentoga: Enjoy guaranteed replies in 1-on-1 chats, book personal meetings, or express your appreciation for their work. Secure your exclusive access and deepen your connection today!`;
    const ogUrl = window.location.href;
    this.metaService.updateMetaTags(
      title,
      description,
      null,
      title,
      description,
      ogUrl,
    );
  }
  loginByGuest() {
    const data = {
      email: this.GuestForm.controls['email'].value,
      productId: 0,
      slotId: 0,
      contactId: 0,
    };
    this.http
      .alternateLoaderPost('api/Guest/add-guest-by-email', data, false, true)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          LoaderService.loader.next(false);
        }),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe(
        (response) => {
          localStorage.removeItem('guestDetails');
          localStorage.removeItem('guestUser');
          const data = {
            token: response?.model?.token,
            id: response?.model?.id,
          };
          this.store.dispatch(addUserData({ user: data }));
          this.helper.showModal(false, 'guestEmail');
          const guestUser = {
            email: this.GuestForm.controls['email'].value,
            isNewUser: response?.model?.isNewUser,
            name: response?.model?.name,
            thirdPartyRegistration: response?.model?.thirdPartyRegistration,
            token: response?.model?.token,
          };
          localStorage.setItem('guestUser', JSON.stringify(guestUser));
          localStorage.setItem('guestUserFrom', 'Package');
          this.GuestForm.reset();
          this.openPackage();
        },
        (err) => {
          this.helper.showModal(true, 'guestEmail');
        },
      );
  }
  showFanEmail() {
    this.handleViewUpdate(false, 'emeetModal');
    this.helper.showModal(true, 'fanEmail');
  }
  informMe() {
    const data = {
      creatorId: this.creatorResponse?.id,
      fanEmail: this.GuestForm.get('email').value,
    };
    this.http
      .loaderPost('api/Home/Inform-me', data, false, true)
      .subscribe((response) => {
        this.helper.showModal(false, 'fanEmail');
        this.GuestForm.reset();
        LoaderService.loader.next(false);
      });
  }
  setupPhone(event) {
    this.helper.showModal(false, 'guestPhone');
    window.open(this.redirectUrl, '_self');
  }

  // Binding the function to the parent context
  getBoundHandleUpdate() {
    return this.subscribePackage.bind(this);
  }

  // Binding the function to the parent context
  getBoundSelectTab() {
    return this.selectTab.bind(this);
  }

  // Binding the function to the parent context
  getBoundAppreciateMe() {
    return this.buyMeACoffee.bind(this);
  }

  getBoundOpenCart() {
    return this.openCart.bind(this);
  }

  // Method to update the modalPackage
  updateModalPackage(newPackage: any) {
    this.modalPackage = newPackage;
  }

  openMobilePackageModal(selectedPackage) {
    this.helper.showModal(true, 'packageMobileModal');
    this.modalPackage = selectedPackage;
  }

  subscribePackage(selectedPackage) {
    localStorage.setItem('selectedPackage', JSON.stringify(selectedPackage));

    setTimeout(() => {
      if (this.localStorageUser) {
        this.redirecToStripe(selectedPackage);
      } else {
        this.helper.showModal(true, 'guestEmail');
      }
    }, 500);
  }
  selectMegaSession(selectedPackage) {
    this.selectedMegaSession = selectedPackage;
  }

  async redirecToStripe(selectedPackage) {
    if (selectedPackage?.price) {
      const guestUser = JSON.parse(localStorage.getItem('guestUser'));
      this.sendProductSelectEventPackage(selectedPackage?.price);
      this.http
        .loaderGet(
          `api/product/package/subscription/checkout/${selectedPackage?.id}`,
          true,
          true,
          true,
        )
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            LoaderService.loader.next(false);
            localStorage.removeItem('selectedPackage');
          }),
          distinctUntilChanged(
            (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
          ),
        )
        .subscribe(
          (response) => {
            const data = {
              amount: selectedPackage?.price,
              productDetails: selectedPackage?.name,
              product: 'Packages',
              paymentGateway: 'Stripe',
              paymentMethod: 'Master Card',
              creatorName: this.creatorResponse?.fullName,
              username: this.creatorResponse?.mentorDetails?.[0]?.userName,
            };
            localStorage.setItem('packagesBuy', JSON.stringify(data));
            window.open(response?.model?.url, '_self');
          },
          (err) => {
            if (guestUser) {
              this.helper.removeGuestUser();
            }
          },
        );
    }
  }

  sendProductSelectEventPackage(price) {
    this._commonService.pixelAction(
      'Product Select',
      this.creatorResponse?.id,
      this.currentUrl,
      this.creatorResponse?.fullName?.toLowerCase(),
      'Packages',
      price,
      this.creatorResponse?.email?.toLowerCase(),
      null,
      null,
      null,
      null,
      this.creatorResponse?.mentorDetails?.[0]?.uniqueName,
    );
  }

  getMegaSessionDate(_session: any) {
    if (!_session) {
      return '';
    }

    const firstSlot = _session.slots[0];
    return this.helper.formatDate(firstSlot?.slotDatetime, firstSlot?.fromTiming);
  }

  toggleText(): void {
    this.showFullBio = !this.showFullBio;
  }

  openCart() {
    console.log('opencart 1');
    this.cartModal = true;
    this.openModal();
  }

  handleRemoveFromCart(itemToRemove: any) {
    this.cartItems = this.cartItems.filter(item => item.recordingId !== itemToRemove.recordingId);
    localStorage.setItem('cartItems', JSON.stringify(this.cartItems));
  }

  handleCheckout() {
    console.log('Checkout with:', this.cartItems);
    // You can add logic here like sending to API or navigating
    // if (this.cartItems?.length == 1) {
    //   localStorage.setItem('paymentDetails', JSON.stringify(paymentRouteData));
    //   this.router.navigate([
    //     `/${this.uniqueName}/recording/${this.cartItems[0].id}`,
    //   ]);
    //   return;
    // }
    let paymentRouteData = {
      menteeID: 0,
      slotID: this.cartItems[0].slot.id,
      type: 'forMe',
      productType: this.cartItems?.map(i => i.title),
      recordingId: 0
    };
    localStorage.setItem('paymentDetails', JSON.stringify(paymentRouteData));
    this.router.navigate([
      `/checkout`,
    ]);
    // alert('Checked out successfully!');
    // this.cartItems = [];
    // this.cartModal = false;
  }
  isInCart(session: any): boolean {
    return this.cartItems?.some(item => item.recordingId === session.recordingId);
  }

  /**
   * Parses the time string and returns a Date object.
   */
  private parseTime(slotDatetime: string, time: string): Date {
    const [, hourStr, minuteStr, period] =
      time.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i) || [];
    if (!hourStr || !minuteStr || !period) {
      console.error(`Invalid time format: ${time}`);
      return new Date(slotDatetime); // Fallback to default datetime
    }
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const date = new Date(slotDatetime);
    date.setHours(
      period.toUpperCase() === 'PM' && hour !== 12
        ? hour + 12
        : period.toUpperCase() === 'AM' && hour === 12
          ? 0
          : hour,
      minute,
    );

    return date;
  }

  /**
   * Calculates the duration in minutes between two Date objects.
   */
  private calculateDuration(from: Date, to: Date): number {
    const duration = (to.getTime() - from.getTime()) / (1000 * 60); // Duration in minutes

    if (duration < 0) {
      console.error(`Invalid duration calculation. From: ${from}, To: ${to}`);
      return 0; // Handle negative durations
    }
    return duration;
  }

  private formatDate(dateString: string): string {
    const date = new Date(dateString);

    // Get day, month (short name), and year
    const day = date.getDate().toString().padStart(2, '0'); // Ensure 2-digit day
    const month = date.toLocaleString('en-US', { month: 'short' }); // Short month name (e.g., "Dec")
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  }
}
